import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CameraSource } from '@capacitor/camera';
import { CameraService } from '../../camera.service';
import { ApiService } from '../../services/api/api.service';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { FileItem } from './file-item.interface';

@Component({
    selector: 'app-file-selection-dialog',
    template: '',
    standalone: false,
})
export class FileSelectionDialogComponent {
    private secure = '';
    private multiple = false;
    private currentPath = '';

    constructor(
        private dialogRef: MatDialogRef<FileSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) { secure, multiple, files, currentPath, directCamera, photoLib },
        private confirmDialogService: ConfirmDialogService,
        private apiService: ApiService,
        private cameraService: CameraService
    ) {
        this.currentPath = currentPath ? `/${currentPath}` : '';
        this.secure = secure;
        this.multiple = multiple;
        if (files) {
            this.uploadFiles(files);
        }
        if (directCamera) {
            this.camera(photoLib);
        }
    }

    private uploadFiles(files: File[]) {
        const uploadedFiles: FileItem[] = [];
        for (let i = 0; i < files.length; i++) {
            if (files[i].size && files[i].size >= 110664300) {
                this.confirmDialogService.confirm(
                    'Bestand te groot',
                    `${files[i].name} is te groot, de maximale grootte is 100MB.`,
                    'Oké'
                );
                continue;
            }

            this.apiService
                .makeFileRequest$<FileItem>('file-manager/upload', files[i], {
                    path: this.currentPath,
                    root: !this.currentPath ? 'true' : '',
                    secure: this.secure,
                })
                .subscribe(
                    data => {
                        if (!data.success) {
                            this.uploadErrorMessage(data['error']['upload'][0]);
                            return;
                        }
                        if (!this.multiple) {
                            this.dialogRef.close([data.data]);
                            return;
                        }
                        uploadedFiles.push(data.data);
                        if (uploadedFiles.length === files.length) {
                            this.dialogRef.close(uploadedFiles);
                        }
                    },
                    error =>
                        this.uploadErrorMessage(
                            `Bestand: ${files[i].name}<br>${error['errormessage'] ? error['errormessage'] : 'Je kunt dit niet uploaden!'}`
                        )
                );
        }
    }

    private camera(photoLib?: boolean) {
        this.cameraService.getPicture(photoLib ? CameraSource.Photos : CameraSource.Camera).then((base64: string) => {
            const byteString = atob(base64);
            const byteArray = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                byteArray[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([byteArray], { type: 'image/jpg' });
            blob['lastModifiedDate'] = new Date();
            blob['name'] = Math.floor(new Date().getTime() * Math.random()) + '.jpg';
            blob['fileName'] = blob['name'];
            this.uploadFiles([blob as File]);
        });
    }

    private uploadErrorMessage(message) {
        this.confirmDialogService.confirm('Er is iets foutgegaan bij het uploaden', `${message}`, 'Oké');
    }
}
